import React from "react";
import "./SuccessCard.css";
import { SuccessIcon } from '../icons/successIcon';

const SuccessCard = ({ title, description }) => {
  return (
    <div className="success-card">
      <div className="col-12">
        <div className="row">
          <div className="col-auto my-auto">
            <SuccessIcon size={20} color="#000" fillColor="#81EC88" />
          </div>
          <div className="col pl-0">
            <div className="success-title">{title}</div>
            <p className="success-text">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessCard;
